module.exports = __webpack_public_path__ + "pitt_logo-696441a476a49284bec778a54b346554.png";